// extracted by mini-css-extract-plugin
export default {"SelfLabel":"_SelfLabel--FL6TS"};